import { Navigate, Outlet, useLocation } from 'react-router-dom';

import useAuth from '../../common/hooks/user/useAuth';

const AnonymousOnlyRoute = () => {
  const { authenticated } = useAuth();
  const location = useLocation();

  if (authenticated && location.pathname.startsWith('/auth')) {
    return <Navigate to="/" />;
  }

  return <Outlet />;
};

export default AnonymousOnlyRoute;
